import { render, staticRenderFns } from "./SuporteFab.vue?vue&type=template&id=3a91213b&scoped=true&lang=pug"
import script from "./SuporteFab.vue?vue&type=script&lang=js"
export * from "./SuporteFab.vue?vue&type=script&lang=js"
import style0 from "./SuporteFab.vue?vue&type=style&index=0&id=3a91213b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91213b",
  null
  
)

export default component.exports